export enum TransactionRuleConditionsEnum {
  NotSet = 0,
  Equals = 1,
  StartsWith = 2,
  EndsWith = 3,
  Contains = 4,
  DoesNotEqual = 5,
  DoesNotContain = 6
}
